export default {
  'menu.home': 'Trang chủ',
  'menu.post-management': 'Quản lý bài viết',
  'menu.post-management.list': 'Danh sách bài viết',
  'menu.post-management.category': 'Danh mục bài viết',
  'menu.post-management.add': 'Tạo bài viết',
  'menu.post-management.edit': 'Sửa bài viết',
  'menu.service-management': 'Quản lý dịch vụ',
  'menu.customer-management': 'Quản lý khách hàng',
  'menu.customer-management.list': 'Danh sách khách hàng',
  'menu.customer-management.detail': 'Lịch sử đặt vé',
  'menu.staff-management': 'Quản lý CBCNV',
  'menu.staff-management.list': 'Danh sách nhân viên',
  'menu.staff-management.role': 'Danh sách chức vụ',
  'menu.interface-management': 'Quản lý giao diện',
  'menu.interface-management.banner': 'Quản lý banner',
  'menu.login': 'Đăng nhập',
  'menu.exception.404': 'Không tìm thấy',
  'menu.ticket-management': 'Quản lý vé',
};
